export function replaceOrInsert<T>(array: T[], item: any) {
  // @ts-ignore
  const indexOldElement = array.findIndex(({ id }) => id === item.id);
  if (indexOldElement >= 0) {
    return Object.assign([...array], { [indexOldElement]: item });
  }
  return [...array, item];
}
